module.exports = __webpack_public_path__ + "img/banner.568f3b1.webp";